import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useGetLoanApplicationByTask } from '../../../services/loanService';
import type { Error } from '../../../services/schemas/loanServiceSchemas';
import './DocumentManagement.css';

const DocumentManagement: React.FC = () => {
  const { taskId } = useParams<{ taskId: string }>();
  const navigate = useNavigate();

  const {
    data: loanApplication,
    isLoading: isLoadingApplication,
    error: applicationError
  } = useGetLoanApplicationByTask(taskId || '', {
    query: {
      enabled: !!taskId
    }
  });

  if (isLoadingApplication) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (applicationError) {
    return (
      <div className="alert alert-danger">
        <i className="bi bi-exclamation-triangle me-2"></i>
        Error loading loan application: {(applicationError as Error)?.message || 'Unknown error'}
      </div>
    );
  }

  return (
    <div className="document-management">
      <div className="page-header mb-4">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h4 className="mb-0">
              <i className="bi bi-file-earmark-text me-2 text-primary"></i>
              Document Management
            </h4>
            <p className="text-muted mb-0">
              Manage documents for loan application #{loanApplication?.id}
            </p>
          </div>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => navigate(`/document-upload/${taskId}`)}
          >
            <i className="bi bi-plus-lg me-2"></i>
            Add Document
          </button>
        </div>
      </div>
    </div>
  );
};

export default DocumentManagement; 